import DecommissionStatus from "~/models/enums/DecommissionStatus.enum";

export const primaryButtonDisabledClasses = (disabled: boolean) => `
  top-[100px] 
  left-[120px] 
  p-2 
  px-4 
  gap-2 
  rounded-tl-[2px] 
  rounded-tr-none 
  rounded-br-none 
  rounded-bl-none
  opacity-[0.45] 
  ${disabled ? 'cursor-not-allowed' : ''}
`;

export const primaryButtonClasses = (disabled:boolean) => `
  bg-Foundation/Primary
  border 
  border-[#FFFFFF] 
  focus:border-2 
  focus:border-white 
  focus:shadow-[0_0_0_2px_#B60F8D]
  hover:bg-Foundation/Primary-Dark
  active:bg-Foundation/Primary-Darker
  w-[163px] 
  h-[44px] 
  top-[100px] 
  left-[120px] 
  p-[8px_16px] 
  gap-[8px] 
  rounded-tl-[2px] 
  rounded-tr-none 
  rounded-br-none 
  rounded-bl-none
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;

export const buttonSecondaryClasses = (disabled:boolean) => `
  bg-white 
  border-2 
  border-Primary
  text-Primary 
  hover:bg-Foundation/Secondary-Extra-light
  active:bg-[#B60F8D] 
  focus:outline-none 
  focus:ring-2 
  focus:ring-Neutral/White
  focus:shadow-[0_0_0_2px_#002B6E]
  w-[165px] 
  h-[44px] 
  top-[100px] 
  left-[120px] 
  p-[8px_16px] 
  gap-[8px] 
  rounded-tl-[2px] 
  rounded-tr-none 
  rounded-br-none 
  rounded-bl-none
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;

export const buttonLinkClasses = (disabled:boolean) => `
  focus:border-[#FFFFFF] 
  focus:outline-none 
  focus:ring-2 
  focus:ring-Primary
  hover:bg-primary-extra-light
  hover:text-Primary
  active:bg-[#A0C0FA] 
  active:text-primary-dark
  w-[161px] 
  h-[44px]  
  top-[100px] 
  left-[120px] 
  p-[8px_16px] 
  gap-[8px] 
  rounded-tl-[2px] 
  border-t-2 
  border-l-2 
  border-transparent
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;

export const buttonDangerClasses = (disabled:boolean) => `
  bg-[#CA3532] 
  text-white 
  opacity-100 
  hover:bg-on-error-container
  active:bg-[#290909] 
  focus:border-2 
  focus:border-white 
  focus:shadow-[0_0_0_2px_#031636]
  w-[161px] 
  h-[44px] 
  top-[100px] 
  left-[120px] 
  p-[8px_16px] 
  gap-[8px] 
  rounded-tl-[2px]
  rounded-tr-none 
  rounded-br-none 
  rounded-bl-none
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;


export const labelPrimaryClasses = `
  font-arial 
  text-[16px] 
  font-normal 
  leading-[28px] 
  text-center 
  text-[#FFFFFF] 
  whitespace-nowrap
`;

export const labelSecondaryClasses = `
  font-arial 
  text-[16px] 
  font-normal 
  leading-[28px] 
  text-center 
  text-primary-dark
  whitespace-nowrap
`;

export const labelLinkClasses = `
  font-arial 
  text-[16px] 
  font-normal 
  leading-[28px] 
  text-center 
  text-Primary
  whitespace-nowrap
`;

export const labelDangerClasses = `
  font-arial 
  text-[16px] 
  font-normal 
  leading-[28px] 
  text-center 
  text-white
`;
export function getButtonClasses(status: DecommissionStatus): string {
  const baseClasses = [
    'flex',
    'items-center',
    'justify-center',
    'w-[220px]',
    'h-[40px]',
    'gap-[4px]',
    'rounded-full',
    'transition',
    'duration-200',
    'cursor-pointer',
  ].join(' ');

  const statusStyles = {
    [DecommissionStatus.PROVISIONING]: {
      bgColor: 'bg-Foundation/Error-Light',
      borderColor: 'border-Foundation/Error-Dark',
      textColor: 'text-Foundation/Error-Dark'
    },
    [DecommissionStatus.PRE_DECOMMISSIONING]: {
      bgColor: 'bg-Foundation/Warning',
      borderColor: 'border-Foundation/Warning-Dark',
      textColor: 'border-Foundation/Warning-Dark'
    },
    [DecommissionStatus.ACTIVATED]: {
      bgColor: 'bg-primary-extra-light',
      borderColor: 'border-Primary',
      textColor: 'text-Primary'
    },
    [DecommissionStatus.DECOMMISSIONED]: {
      bgColor: 'bg-Foundation/Error-Light',
      borderColor: 'border-Foundation/Error-Dark',
      textColor: 'text-Foundation/Error-Dark'
    }
  };

  const { bgColor, borderColor, textColor } = statusStyles[status] || {
    bgColor: 'bg-primary-extra-light',
      borderColor: 'border-Primary',
      textColor: 'text-Primary'
    }
    ;

  return `${baseClasses} ${bgColor} ${borderColor} ${textColor}`;
}